<app-page>
    <app-title>{{ 'unacked_and_paid_orders' | translate }}</app-title>
    <app-orders [ordersModel]="unackedAndPaidOrdersModel"></app-orders>
</app-page>
